import {
  action as originAction,
  actionBound as originActionBound,
  batch as originBatch,
  batchBound as originBatchBound,
  untrack as originUntrack,
  untrackBound as originUntrackBound
} from '../signal'
import { originBind } from './bind'
import { originTrigger } from './trigger'

import type { BindTrigger, Boundary } from '../types'
import type { TFunction } from '@rehaje/shared'

let bridgeBatch: Boundary | undefined
let bridgeUntrack: Boundary | undefined

export let action = originAction
export let actionBound = originActionBound
export let batch = originBatch
export let batchBound = originBatchBound
export let bind = originBind
export let trigger = originTrigger
export let untrack = originUntrack
export let untrackBound = originUntrackBound

export function registerBatch(registerBatch?: Boundary) {
  if (registerBatch === undefined) {
    bridgeBatch = registerBatch
    batch = originBatch
    batchBound = originBatchBound
    adaptAction()
  } else if (typeof registerBatch === 'function') {
    bridgeBatch = registerBatch
    batch = (fn) => registerBatch(() => originBatch(fn))
    batchBound = (fn) => {
      return function (this: any, ...args: any[]) {
        return registerBatch(() => originBatch(() => fn.apply(this, args)))
      } as TFunction
    }
    adaptAction()
  }
}

export function registerBind(bridgeBind?: BindTrigger) {
  if (bridgeBind === undefined) bind = originBind
  else if (typeof bridgeBind === 'function') {
    bind = (object, key) => {
      bridgeBind(object, key)
      originBind(object, key)
    }
  }
}

export function registerTrigger(bridgeTrigger?: BindTrigger) {
  if (bridgeTrigger === undefined) trigger = originTrigger
  else if (typeof bridgeTrigger === 'function') {
    trigger = (object, key) => {
      bridgeTrigger(object, key)
      originTrigger(object, key)
    }
  }
}

export function registerUntrack(registerUntrack?: Boundary) {
  if (registerUntrack === undefined) {
    bridgeUntrack = registerUntrack
    untrack = originUntrack
    untrackBound = originUntrackBound
    adaptAction()
  } else if (typeof registerUntrack === 'function') {
    bridgeUntrack = registerUntrack
    untrack = (fn) => registerUntrack(() => originUntrack(fn))
    untrackBound = (fn) => {
      return function (this: any, ...args: any[]) {
        return registerUntrack(() => originUntrack(() => fn.apply(this, args)))
      } as TFunction
    }
    adaptAction()
  }
}

function adaptAction() {
  if (bridgeBatch === undefined && bridgeUntrack === undefined) {
    action = originAction
    actionBound = originActionBound
  } else if (bridgeBatch === undefined) {
    action = (fn) => bridgeUntrack!(() => originAction(fn))
    actionBound = (fn) => {
      return function (this: any, ...args: any[]) {
        return bridgeUntrack!(() => originAction(() => fn.apply(this, args)))
      } as TFunction
    }
  } else if (bridgeUntrack === undefined) {
    action = (fn) => bridgeBatch!(() => originAction(fn))
    actionBound = (fn) => {
      return function (this: any, ...args: any[]) {
        return bridgeBatch!(() => originAction(() => fn.apply(this, args)))
      } as TFunction
    }
  } else {
    action = (fn) => bridgeBatch!(() => bridgeUntrack!(() => originAction(fn)))
    actionBound = (fn) => {
      return function (this: any, ...args: any[]) {
        return bridgeBatch!(() =>
          bridgeUntrack!(() => originAction(() => fn.apply(this, args)))
        )
      } as TFunction
    }
  }
}
